"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    color: theme.palette.elementHeadline,
    paddingBottom: theme.spacing(0.5),
    "& span": {
      display: "inline-block",
      position: "relative",
      "&::before": {
        background: theme.palette.primary.main,
        bottom: theme.spacing(-0.5),
        content: "''",
        height: 1,
        left: 0,
        position: "absolute",
        width: 60
      }
    }
  }
}));
const ElementHeadline = _ref => {
  let {
    title,
    component,
    uppercase = true
  } = _ref;
  const css = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css.root,
    style: {
      textTransform: uppercase && "uppercase"
    },
    variant: "h3",
    component: component
  }, /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: title
    }
  }));
};
var _default = exports.default = ElementHeadline;